import styled from 'styled-components'

export default function Rich({ children }) {
    return (
        <Container>
            <div
                dangerouslySetInnerHTML={{
                    __html: children
                }}
            />
        </Container>
    )
}

const Container = styled.div`
    h2 {
        font-size: 0.22rem;
        line-height: 1.27;
        margin: 0 0 0.16rem 0;
        font-weight: 600;
    }
    p {
        margin: 1.375em 0;
    }
    ul {
        margin: 1.375em 0;
        padding: 0;
    }
    iframe {
        width: 100% !important;
    }
    li {
        list-style: none;
        position: relative;
        padding-left: 0.14rem;
        margin: 1.375em 0;
        p {
            margin: 0;
        }
        &:before {
            content: '•';
            position: absolute;
            color: var(--color-orange);
            left: 0;
        }
    }
    a {
        text-decoration: underline;
        color: var(--color-blue);
        &:hover {
            text-decoration: none;
        }
    }
`
// font-size: 0.16rem;
// b,
// strong {
//     color: var(--color-dark);
// }
// ul,
// ol {
//     padding: 0 0 0 1em;
// }
// ul,
// ol,
// p {
//     margin: 0.24rem 0;
// }
// h2 {
//     font-size: 0.24rem;
//     margin: 0;
//     padding: 0.24rem 0 0.24rem 0;
//     + * {
//         margin-top: 0;
//     }
//     a {
//         text-decoration: none;
//     }
// }
// h3 {
//     font-size: 0.18rem;
// }
// h4 {
//     font-size: 0.14rem;
// }
// a {
//     text-decoration: underline;
//     &:hover {
//         text-decoration: none;
//     }
// }
// *:first-child {
//     margin-top: 0;
// }
// ${device.mobile} {
//     font-size: 0.12rem;
//     ul,
//     ol,
//     p {
//         margin: 0.18rem 0;
//     }
//     h2 {
//         font-size: 0.18rem;
//         padding: 0.18rem 0;
//         + * {
//             margin-top: 0;
//         }
//     }
//     h3 {
//         font-size: 0.14rem;
//     }
//     h4 {
//         font-size: 0.12rem;
//     }
// }
